__turbopack_context__.v({
  "icon": "AdminPanelLink-module__9Z26na__icon",
  "label": "AdminPanelLink-module__9Z26na__label",
  "link": "AdminPanelLink-module__9Z26na__link",
});
